export var MuiListItemText = {
    styleOverrides: {
        multiline: {
            display: 'flex',
            flexDirection: 'column',
            height: 56,
            justifyContent: 'center',
            marginBottom: 0,
            marginTop: 0,
        },
    },
    customOverrides: {
        sideNavItemText: {
            marginTop: 0,
            marginBottom: 0,
        },
    },
};
